import AbstractValue from '@/models/app-config/behavior/abstract-value'
import { AddToCartButton } from './order-history/add-to-cart-button'

export interface RawOrderHistory {
  addToCartButton: {
    enabled: boolean
  }
}

export class OrderHistory extends AbstractValue<RawOrderHistory> {
  get addToCartButton(): AddToCartButton {
    return new AddToCartButton(this.raw.addToCartButton)
  }
}
